export const titleVariants = {
  normal: "font-normal",
  default: "font-semibold",
  bold: "font-bold",
  italic: "italic",
  uppercase: "uppercase",
  medium: "font-medium",
};

export const titleMarginVariants ={
  default: "mb-3",
  medium: "mb-5"
}

export const titleSizeVariants = {
  default: "",
  xsmall: "text-sm",
  small: "text-lg",
  medium: "md:text-xl text-lg",
  large: "text-2xl",
  xlarge: "text-3xl",
  xxlarge: "text-4xl",
  featured: "md:text-4xl text-2xl"
};

export const descriptionVariants = {
  default: "text-base",
  small: "text-sm",
  large: "text-lg",
  italic: "italic",
};

export const descriptionSizeVariants = {
  small: "text-sm",
  medium: "text-base",
  large: "text-lg",
  xlarge: "text-xl",
};

export const descriptionLineClampVariants = {
  default: "line-clamp-2",
  one: "line-clamp-1",
  two: "line-clamp-2",
  three: "line-clamp-3",
  four: "line-clamp-4",
  five: "line-clamp-5",
  six: "line-clamp-6",
  none: "",
};

export const titleLineClampVariants = {
  default: "",
  one: "line-clamp-1",
  two: "line-clamp-2",
  three: "line-clamp-3",
  four: "line-clamp-4",
  five: "line-clamp-5",
  six: "line-clamp-6",
  none: "",
};

export const imageVariants = {
  default: "rounded",
  rounded: "rounded",
  roundedLg: "rounded-lg",
  circle: "rounded-full",
};

export const imageSizeVariants = {
  default: "",
  small: "w-20 h-20",
  medium: "w-24 h-24",
  large: "w-28 h-28",
  xlarge: "w-32 h-32",
};


export const hoverVariants = {
  default: "",
  hoverZoom: "hover:scale-105 transition-transform duration-300",
  hoverZoomIn: "hover:scale-105 transition-transform duration-300",
  hoverZoomOut: "hover:scale-95 transition-transform duration-300",
  hoverZoomInOut:
    "hover:scale-105 hover:scale-95 transition-transform duration-300",
  hoverZoomInOutScale:
    "hover:scale-105 hover:scale-95 transition-transform duration-300",
  hoverZoomInOutScaleOpacity:
    "hover:scale-105 hover:scale-95 hover:opacity-80 transition-transform duration-300",
};

export const layoutVariants = {
  default: "flex flex-col",
  vertical: "flex flex-col",
  horizontal: "flex flex-row",
  horizontalReverse: "flex flex-row-reverse",
  withImage: "flex flex-row items-center",
  imageOnly: "",
};
